import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

export const PlayIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["brand.500"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Path
      d="M18.182 11.08 6.707 5.341a1.023 1.023 0 0 0-1.453.914v11.47a1.018 1.018 0 0 0 1.482.915l11.446-5.738a1.023 1.023 0 0 0 0-1.829v.005Z"
      fill={color}
    />
  </Svg>
);
